const relationCheck = {
  // 等于 <目前只使用了等于条件的判断>
  equal: function(inpVal, relaVal) {
    if (inpVal && relaVal) {
      return inpVal == relaVal
    }
    return false
  },
  // 大于
  greater: function(inpVal, relaVal) {
    // let tempInp = typeof inpVal === 'number' && !isNaN(inpVal)
    // let tempRela = typeof relaVal === 'number' && !isNaN(relaVal)
    if (inpVal && relaVal) {
      return inpVal > relaVal
    }
    return false
  },
  // 大于等于
  greaterOrequal: function(inpVal, relaVal) {
    if (inpVal && relaVal) {
      return inpVal >= relaVal
    }
    return false
  },
  // 小于
  less: function(inpVal, relaVal) {
    if (inpVal && relaVal) {
      return inpVal < relaVal
    }
    return false
  },
  // 小于等于
  lessOrequal: function(inpVal, relaVal) {
    if (inpVal && relaVal) {
      return inpVal <= relaVal
    }
    return false
  },

  // 不等于
  noequal: function(inpVal, relaVal) {
    return inpVal != relaVal
  },
  // 包含
  contain: function(inpVal, relaVal) {
    if (inpVal && relaVal) {
      return inpVal.indexOf(relaVal) === -1 ? false : true
    }
    return false
  },
  // 不包含
  nocontain: function(inpVal, relaVal) {
    if (inpVal && relaVal) {
      return inpVal.indexOf(relaVal) === -1 ? true : false
    }
    return false
  },
  // 介于
  between: function(inpVal, relaVal) {
    if (inpVal && relaVal) {
      return inpVal.indexOf(relaVal) === -1 ? true : false
    }
    return false
  },
  // 早于
  earlier: function(inpVal, relaVal) {
    if (inpVal && relaVal) {
      return inpVal.indexOf(relaVal) === -1 ? true : false
    }
    return false
  },
  // 晚于
  later: function(inpVal, relaVal) {
    if (inpVal && relaVal) {
      return inpVal.indexOf(relaVal) === -1 ? true : false
    }
    return false
  }
}

export { relationCheck }
